import { render, staticRenderFns } from "./clipboard-alert.vue?vue&type=template&id=d1f41f30&scoped=true"
import script from "./clipboard-alert.vue?vue&type=script&lang=js"
export * from "./clipboard-alert.vue?vue&type=script&lang=js"
import style0 from "./clipboard-alert.vue?vue&type=style&index=0&id=d1f41f30&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1f41f30",
  null
  
)

export default component.exports